import { ref, watchEffect } from 'vue'
import type { ObjectTypeType } from './types'
import { useLoadObjectTypes } from './api.ts'
import { useTranslate } from '@/shared/lib'

export const useModel = () => {
  const { trs } = useTranslate()

  const data = ref<ObjectTypeType[]>([])

  /**
   * Настройки шапки формы
   */
  const headers = ref([
    { title: trs('itf.id'), key: 'id', sortable: false },
    { title: trs('itf.object_types_name'), key: 'object_name', sortable: false },
    { title: trs('itf.icon'), key: 'icon', sortable: false },
    { title: trs('itf.description'), key: 'description', sortable: false },
    { title: trs('itf.objects_group'), key: 'default_group_object_id', sortable: false },
    { title: trs('itf.action'), key: 'action', sortable: false },
  ])

  /**
   * Функция загрузки данных
   */
  const loadData = () => {
    const result = useLoadObjectTypes()

    watchEffect(() => {
      if (result.data.value) {
        data.value = result.data.value.data || []
      }
    })

    return result
  }

  return {
    data,
    headers,

    loadData,
  }
}
